<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trail="trails[0].trail" :subTrail="` > ${trails[1].trail}`" :href="trails[0].href"></crumbs>
    <div class="main-view">
      <div class="view-form">
        <div class="data-form text" v-show="searchRule">
          <label>计划ID：</label>
          <el-autocomplete
            v-model="planId"
            size="small"
            :maxlength="1===1?8:0"
            :fetch-suggestions="querySearchAsyncId"
            placeholder="请输入"
          ></el-autocomplete>
        </div>
        <div class="data-form text">
          <label>计划名称：</label>
          <el-autocomplete
            v-model="planName"
            size="small"
            :fetch-suggestions="querySearchAsyncName"
            placeholder="请输入"
          ></el-autocomplete>
        </div>
        <div class="data-form text">
          <label>广告类型：</label>
          <el-select v-model="advertisingType" size="small" placeholder="请选择">
            <el-option
              v-for="item in advertisingTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="data-form text" v-show="searchRule">
          <label>广告运营：</label>
          <el-select v-model="advertisingOperating" size="small" filterable placeholder="请选择">
            <el-option
              v-for="item in advertisingOperatingList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="data-form time">
          <label>统计时间：</label>
          <el-date-picker
            v-model="dataTime"
            type="daterange"
            size="small"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="data-form btn">
          <el-button type="primary" size="small" @click="search()">搜索</el-button>
          <el-button type="primary" size="small" @click="downLoad()">导出数据</el-button>
        </div>
      </div>
      <div class="view-title">
        <i class="el-icon-menu"></i>
        <span>分广告数据（{{dataSize}}）</span>
      </div>
      <div class="view-table">
        <el-table
          class="table-list"
          :data="tableData"
          @sort-change="changeSort"
          style="width: 100%">
          <el-table-column prop="StatisDate" label="日期" width="120" align="center"></el-table-column>
          <el-table-column prop="PutOnId" label="计划ID" width="100" align="center" v-if="searchRule"></el-table-column>
          <el-table-column prop="AdTaskName" label="计划名称" width="180" align="center"></el-table-column>
          <el-table-column prop="AdrName" label="广告主名称" width="180" align="center" v-if="searchRule"></el-table-column>
          <el-table-column prop="OperationUserName" label="广告运营" width="110" align="center" v-if="searchRule"></el-table-column>
          <el-table-column prop="ExposureCount" label="曝光" width="110" align="center" sortable></el-table-column>
          <el-table-column prop="ClickPvCount" label="计费点击" width="110" align="center" sortable></el-table-column>
          <el-table-column prop="ClickUvCount" label="点击uv" width="110" align="center" sortable></el-table-column>
          <el-table-column prop="InCome" label="日消耗" width="100" align="center" sortable></el-table-column>
          <el-table-column prop="VisitPvCount" label="落地页访问pv" width="150" align="center" sortable></el-table-column>
          <el-table-column prop="VisitUvCount" label="落地页访问uv" width="150" align="center" sortable></el-table-column>
          <el-table-column prop="TransferPvCount" label="转化pv" width="100" align="center" sortable></el-table-column>
          <el-table-column prop="AccessPrice" label="点击均价" width="110" align="center" sortable></el-table-column>
          <el-table-column prop="CTR" label="ctr（点击率）" width="150" align="center" sortable></el-table-column>
          <el-table-column prop="CVR" label="cvr（转化率）" width="150" align="center" sortable></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <el-pagination v-show="dataSize > 20" background layout="prev, pager, next" :total="dataSize" :page-size="pageSize" :current-page="currentPage" @current-change="pageChange">
      </el-pagination>

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  // 面包屑
  import crumbs from "../public/crumbs/crumbs";
  // 审核弹层
  import confirmDialog from "../public/confirm-dialog";
  // 格式化时间
  import { formatDateAll } from "common/js/common";
  // api
  import {
    // 获取用户是否代理运营接口
    GetIsAgent,
    //获取广告计划ID接口
    GetAdvertiseInfo,
    //广告运营
    GetUserAdOperatorUser,
    // 获取分广告数据列表接口
    GetPlanAdstatis,
    //导出分广告数据接口
    ExportPlanAdstatis
  } from "api/customerManagement";

  export default {
    data() {
      return {
        // 面包屑
        trails: [
          {
            trail: "媒体数据",
            href: "/iad_adstatis/sourcestatis"
          },
          {
            trail: "分广告数据",
            href: ""
          }
        ],
        advertisingOperatingList: [{
          value: '',
          label: '全部运营'
        }],
        planIdList: [],
        planNameList: [],
        planId: '',
        planIdSet: '',
        planName: '',
        advertisingTypeList: [{
          value: -1,
          label: '请选择'
        }, {
          value: 0,
          label: '广告'
        }, {
          value: 1,
          label: '奖品'
        }],
        advertisingType: -1,
        advertisingOperating: '',
        dataTime: [new Date(), new Date()],
        dataNumber: 0,
        tableData: [],
        dataSize: 0,
        pageSize: 20,
        currentPage: 1,
        tableMinHeight: 30,
        timeout:  null,
        searchRule: true,
        MediaId: '',
        SortField: '',
        SortType: ''
      };
    },
    components: {
      // 面包屑
      crumbs,
      // 审核弹框
      confirmDialog
    },
    methods: {
      search() {
        let params = {
          SourceId: this.MediaId,  //媒体Id
          PutOnId: this.planId, //计划Id
          AdTaskName: this.planId? '':this.planName, //计划名称
          AwardType: this.advertisingType, //广告类型
          AdOperatorUserId: this.advertisingOperating,  //广告运营
          StartDate: this.timeFormat(this.dataTime[0]),  //开始时间
          EndDate: this.timeFormat(this.dataTime[1]),   //结束时间
          SortField: this.SortField,  //排序字段
          SortType: this.SortType,   //排序顺序
          PageIndex: this.currentPage
        };
        GetPlanAdstatis(params).then( res =>{
          if(res.success) {
            this.tableData = res.list;
            this.dataSize = res.totalcount;
          }
        })
      },
      pageChange(value) {
        this.currentPage = value;
        this.search();
      },
      changeSort(column) {
        let sortValue = column.prop === 'CTR'? 'CTR':column.prop;
        let sortPick = column.order === 'ascending'? 'asc':'desc';
        if(sortValue && sortPick) {
          this.SortField = sortValue;
          this.SortType = sortPick;
        } else {
          this.SortField = '';
          this.SortType = '';
        }
        this.search();
      },
      querySearchAsyncName(queryString, cb) {
          let restaurants = this.planNameList;
        let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        });
      },
      querySearchAsyncId(queryString, cb) {
        let restaurants = this.planIdList;
        let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        });
      },
      createStateFilter(queryString) {
        return (state) => {
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
        };
      },
      // 获取用户是否代理运营
      GetIsAgent() {
        GetIsAgent().then( res => {
          this.searchRule = !res.isagent;
        })
      },
      //获取计划列表
      GetAdvertiseInfo() {
        GetAdvertiseInfo().then( res => {
          if(res.success) {
            res.list.forEach( (data) => {
              this.planIdList.push({
                value: data.id.toString(),
                label: data.id.toString()
              })
              this.planNameList.push({
                value: data.name,
                label: data.name
              })
            })
          }
        })
      },
      //获取广告运营
      GetUserAdOperatorUser() {
        GetUserAdOperatorUser().then( res =>{
          if(res.success) {
            res.list.forEach( data => {
              this.advertisingOperatingList.push({
                value: data.id.toString(),
                label: data.name
              })
            })
          }
        })
      },
      // 格式化日期
      formatDater(row, column, cellValue, index) {
        return formatDateAll(cellValue);
      },
      timeFormat(date) {
        if(date) {
          let year = date.getFullYear();
          let month = date.getMonth()+1 > 9? (date.getMonth()+1) : '0' + (date.getMonth()+1);
          let day = date.getDate() > 9? date.getDate() : '0' + date.getDate();
          return year + '-' + month + '-' + day;
        }
      },
      downLoad() {
        var params = {
          PutOnId: this.planId,
          SourceId: this.MediaId,
          AdTaskName: this.planId? '':this.planName,
          AwardType: this.advertisingType,
          AdOperatorUserId: this.advertisingOperating,
          StartDate: this.dataTime? this.timeFormat(this.dataTime[0]):'',
          EndDate: this.dataTime? this.timeFormat(this.dataTime[1]):''
        }
        location.href="/IAD_ADStatis/ExportPlanAdstatis?PutOnId=" + params.PutOnId + "&SourceId=" + params.SourceId + "&AdTaskName=" +
          params.AdTaskName + "&AwardType=" + params.AwardType + "&AdOperatorUserId=" +
          params.AdOperatorUserId + "&StartDate=" + params.StartDate + "&EndDate=" + params.EndDate
      }
    },
    watch: {
      planId (value, old) {
        if(isNaN(Number(value))) {
          setTimeout(()=> {
            this.planId = old;
          })
        }
      }
    },
    created() {
      this.tableMinHeight = window.innerHeight - 340;
    },
    mounted() {
      this.MediaId = this.$route.query.SourceId? this.$route.query.SourceId:'';
      this.GetIsAgent();
      this.GetAdvertiseInfo();
      this.GetUserAdOperatorUser();
      this.search();
    }
  };
</script>
<style lang="scss" scoped>
  @import "../../common/scss/color";
.main-view {
  margin: 0 0;
  /*搜索条件*/
  .view-form {
    padding: 10px 10px 0;
    border: 1px solid #F2F2F2;
    &:after {
      content: '';
      display: block;
      clear: both;
    }
    .data-form {
      padding-bottom: 10px;
      float: left;
      margin-right: 20px;
      label {
        width: 80px;
        display: inline-block;
      }
      &.text{
        width: 240px;
      }
      &.time {
        width: 360px;
        .el-date-editor {
          width: 270px;
        }
      }
      .el-input,.el-select,.el-autocomplete {
        width: 150px;
      }
    }
  }
  .view-title {
    color: #bbbbbb;
    margin: 10px 0;
  }
  .view-table {
    /*table表格样式*/
    .el-table.table-list th>.cell {
      font-size: 14px!important;
    }
    .table-list {
      border: 1px solid #ebeef5;
    }

  }
  .el-button   {
    width: 80px;
  }
  .el-pagination {
    text-align:center;
    padding: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/media/media-data.vue